export type Lang = 'es' | 'en'

export const translations: Record<Lang, any> = {
  es: {
    nav: {
      inicio: 'Inicio',
      problema: 'Problema',
      sistema: 'Sistema',
      trabajos: 'Trabajos',
      nosotros: 'Nosotros',
      garantia: 'Garantía',
      faq: 'FAQ',
      tienda: 'Tienda',
      tiendaOnline: 'Tienda Online',
      cotizacion: 'Cotización Gratuita',
      llamar: 'Llamar Ahora',
    },
    hero: {
      badge: 'Especialistas en Remodelación en Florida',
      title: 'Tu Baño Viejo Está Robándote el Orgullo de Tu Hogar Cada Día',
      subtitle:
        'La Solución Que Las Familias Latinas En Florida Han Esperado — Remodelaciones de Elite con Garantía de Satisfacción Total.',
      trust1: '+100 Baños Transformados / Año',
      trust2: 'Empresa Registrada LLC',
      trust3: 'Satisfacción Garantizada',
      cta1: 'Llámanos: 813-753-4656',
      cta2: 'Cotización Gratuita',
      overlayTitle: 'Calidad Elite',
      overlaySub: 'Resultados que duran',
    },
    lead: {
      quote: 'Tu hogar habla de ti antes de que abras la boca.',
      p1: 'Cada vez que alguien entra a tu casa, lo primero que ve no eres tú. Ve las paredes. Ve el piso. Ve ese baño que llevas años queriendo cambiar.',
      p2: 'Y tú lo sabes.',
      p3: 'Sabes que ese baño viejo, esas grietas, esos accesorios que ya no combinan — no reflejan quién eres tú ni todo lo que has trabajado para tener lo que tienes.',
      p4: 'Has soñado con esa transformación. La has visto en Pinterest, en los videos de YouTube, en la casa de ese familiar que finalmente lo hizo.',
      p5: 'Pero algo te ha detenido.',
      p6: 'Quizás fue ese contratista que tomó el depósito y desapareció. Quizás fue el trabajo mal hecho que tuviste que volver a pagar. O quizás simplemente no sabes a quién puedes realmente confiarle tu hogar.',
      p7: 'Eso está a punto de cambiar.',
    },
    problem: {
      title: 'El Problema Real Que Nadie Te Dice',
      desc: 'Déjame ser directo contigo. No es que no tengas el dinero. No es que no tengas el deseo. Es que el mercado de construcción está lleno de personas que hacen promesas que nunca cumplen. Ya lo has visto:',
      p1: 'El contratista que llegó entusiasmado, cobró el depósito... y después, nada.',
      p2: 'El trabajo que quedó "casi bien" pero que a los 6 meses ya estaba fallando.',
      p3: 'Los materiales baratos que usaron mientras te cobraron precio de primera.',
      p4: 'Las llamadas que dejaron de contestar cuando les preguntaste por los detalles.',
      result:
        '¿Y el resultado? Perdiste dinero. Perdiste tiempo. Y lo peor — perdiste la confianza de que alguien pueda realmente transformar tu hogar como tú lo imaginas.',
      conclusion: 'Eso no es un problema tuyo. Es un problema del mercado.',
    },
    cost: {
      title: 'Lo Que Esos Espacios Anticuados Te Están Costando En Realidad',
      p1: 'Mira tu baño ahora mismo. ¿Sabes cuánto te cuesta emocionalmente cada día que pasa sin hacer ese cambio?',
      p2: 'Cada mañana que te lavas la cara en ese lavamanos viejo. Cada vez que tus hijos ven ese piso dañado. Cada vez que tienes visita y secretamente esperas que no usen ese baño. Cada vez que ves las fotos de otras casas renovadas y piensas: "Yo también podría tener eso."',
      p3: 'Ese orgullo que sientes cuando miras una casa bien terminada — lo mereces tú también.',
      p4: 'Tu familia trabaja duro. Merece vivir en un hogar que lo refleje.',
    },
    mechanism: {
      badge: 'La Diferencia JOM Elite',
      title: 'Presentando: El Sistema de Transformación Elite™',
      desc: 'Después de más de 100 remodelaciones de baño completadas exitosamente cada año, hemos perfeccionado un sistema que elimina exactamente los puntos donde otros fallan. Tiene 3 capas:',
      c1Title: 'MATERIALES DE ELITE',
      c1Desc:
        'No usamos lo que está en oferta. No usamos lo que es conveniente para nosotros. Usamos productos de alta calidad rigurosamente probados que cumplen con nuestros estándares internos — que son, francamente, más altos que lo que el mercado exige. ¿Por qué? Porque cuando terminamos un proyecto, nuestro nombre queda en esas paredes. Y eso nos importa más que el costo del material.',
      c2Title: 'EJECUCIÓN CON EXPERIENCIA REAL',
      c2Desc:
        'Hay una diferencia enorme entre alguien que ha hecho 5 baños y alguien que ha hecho más de 100 en un solo año. Nuestro equipo no aprende en tu casa. Ya son expertos cuando llegan a tu puerta. Hemos visto cada tipo de espacio, cada tipo de complicación, cada tipo de desafío — y sabemos exactamente cómo manejarlo sin que te cueste tiempo ni dinero extra.',
      c3Title: 'COMPROMISO DE SATISFACCIÓN TOTAL',
      c3Desc:
        'Este es el que más nos diferencia. Para nosotros, el proyecto no está terminado cuando nosotros decimos que está terminado. Está terminado cuando TÚ estás completamente feliz. Punto. Sin excusas. Sin desaparecer. Sin trabajo a medias. Transformamos tu visión en realidad — o seguimos trabajando hasta lograrlo.',
    },
    portfolio: {
      badge: 'Nuestro Portafolio',
      title: 'Trabajos Reales. Resultados Reales.',
      desc: 'Cada baño que ves aquí fue una visión de una familia — y nosotros la convertimos en realidad. Estos son algunos de los proyectos que entregamos recientemente.',
      p1Title: 'Ducha de Mármol Premium',
      p1Tag: 'Acabados Dorados',
      p2Title: 'Suite Master con Tina Independiente',
      p2Tag: 'Remodelación Total',
      p3Title: 'Ducha de Vidrio Negro Moderno',
      p3Tag: 'Estilo Contemporáneo',
      p4Title: 'Baño Boutique con Piedra Natural',
      p4Tag: 'Diseño Exclusivo',
      p5Title: 'Baño Familiar Elegante',
      p5Tag: 'Acabados de Lujo',
      completed: 'Proyecto Completado',
      s1Num: '100+',
      s1Label: 'Baños / Año',
      s2Num: '0',
      s2Label: 'Clientes Abandonados',
      s3Num: '100%',
      s3Label: 'Satisfacción',
      s4Num: 'LLC',
      s4Label: 'Empresa Registrada',
    },
    about: {
      title: 'Quiénes Somos — Y Por Qué Deberías Confiar En Nosotros',
      p1: 'JOM Elite Construction LLC no es una empresa improvisada.',
      p2: 'Somos una Sociedad de Responsabilidad Limitada registrada oficialmente (Número de archivo: L24000141264) — lo que significa que tenemos la estructura legal, la responsabilidad y el compromiso que viene con una empresa seria.',
      p3: 'Nos especializamos en remodelación moderna del hogar y accesorios premium con un enfoque específico en transformaciones de baño y espacios que elevan la calidad de vida de las familias.',
      p4: 'No hacemos el trabajo y desaparecemos. Somos el tipo de empresa con la que construyes una relación — porque sabemos que cuando tu casa necesite algo en el futuro, quieres llamar a alguien en quien confíes.',
      vTitle: 'Nuestro equipo está construido sobre tres valores:',
      v1: 'Calidad sin compromiso',
      v2: 'Profesionalismo en cada paso',
      v3: 'Satisfacción del cliente, siempre',
    },
    vision: {
      title: 'Lo Que Tu Vida Se Ve Después De La Transformación',
      p1: 'Imagina esto:',
      p2: 'Despiertas mañana por la mañana. Entras a tu baño y lo que ves es limpio, moderno, elegante. Los accesorios brillan. El piso está perfecto. Todo encaja exactamente como lo imaginaste.',
      p3: 'Tus hijos lo notan. Tu pareja lo nota. Cuando llegan visitas, ya no esconden el baño — lo muestran con orgullo.',
      p4: 'Y cada vez que entras a ese espacio, sientes algo que quizás no habías sentido en mucho tiempo en tu propio hogar:',
      word: 'Orgullo.',
      desc: 'Ese es el verdadero resultado que entregamos. No solo un baño nuevo. Un hogar que finalmente refleja quién eres.',
    },
    included: {
      title: 'Lo Que Incluye Trabajar Con JOM Elite',
      desc: 'Cuando nos contratas, no solo contratas mano de obra. Contratas el sistema completo:',
      i1Title: 'Consulta personalizada',
      i1Desc: 'Entendemos tu visión antes de hacer cualquier propuesta',
      i2Title: 'Materiales de alta calidad',
      i2Desc: 'Rigurosamente seleccionados y probados bajo nuestros estándares',
      i3Title: 'Equipo experto certificado',
      i3Desc: 'Profesionales con experiencia en 100+ proyectos por año',
      i4Title: 'Gestión completa del proyecto',
      i4Desc: 'Sin estrés para ti. Nosotros coordinamos todo',
      i5Title: 'Comunicación constante',
      i5Desc: 'Sabes exactamente qué pasa en cada etapa',
      i6Title: 'Garantía de satisfacción',
      i6Desc: 'El trabajo no termina hasta que tú estés feliz',
      i7Title: 'Empresa legalmente registrada',
      i7Desc: 'Protección, transparencia y seriedad institucional',
    },
    supply: {
      badge: 'Tienda Online · JOM Elite Supply',
      title1: '¿Buscas los Mismos Materiales Que Usamos en ',
      title2: 'Nuestras Remodelaciones',
      desc: 'Ahora puedes comprarlos directamente. Visita nuestra tienda online y accede a los mismos accesorios y materiales premium que instalamos en cada proyecto JOM Elite.',
      f1: 'Materiales Premium',
      f2: 'Precios Directos',
      f3: 'Envíos Disponibles',
      cta: 'Visitar Tienda',
    },
    guarantee: {
      title: 'Nuestra Garantía — Sin Letra Pequeña',
      p1: 'Somos tan seguros de nuestro trabajo que lo decimos directamente:',
      quote:
        '"Si no estás satisfecho con el resultado, seguimos trabajando hasta que lo estés."',
      p2: 'Sin excusas. Sin "ya lo revisamos y está bien." Sin desaparecer.',
      p3: 'Tu satisfacción no es una promesa de marketing. Es la forma en que medimos si hicimos nuestro trabajo.',
    },
    urgency: {
      badge: 'Agenda Limitada',
      title: 'Por Qué Actuar Ahora',
      desc: 'Cada día que pasa sin hacer esa remodelación es un día más que:',
      r1: 'Tu hogar no refleja lo que mereces',
      r2: 'Ese espacio sigue deteriorándose y costando más después',
      r3: 'Tu familia sigue viviendo en algo que no los representa',
      r4: 'Pierdes tiempo que podrías haber pasado disfrutando tu hogar transformado',
      limitTitle: 'Nuestra Capacidad Es Limitada',
      limitDesc:
        'Los proyectos de calidad tienen agenda limitada. Nuestro equipo trabaja con un número específico de clientes para garantizar que cada proyecto recibe la atención que merece.',
      limitQuote:
        'Cuando llenes la agenda — ya no hay espacio hasta el siguiente ciclo.',
    },
    oneliners: {
      title: 'Por Qué Las Familias Eligen JOM Elite',
      q1: 'Tu casa habla de ti. Asegúrate de que diga algo bueno.',
      q2: '100 baños transformados este año. El tuyo puede ser el próximo.',
      q3: 'No construimos paredes — construimos orgullo familiar.',
      q4: 'El contratista que no desaparece. Somos JOM Elite.',
      q5: 'Tu visión. Nuestra obsesión con la calidad. Resultado: Tu hogar ideal.',
      q6: 'Cada grieta que ignoras es dinero que estás perdiendo.',
      q7: 'Materiales de elite. Equipo experto. Satisfacción garantizada.',
      q8: '¿Cuántas veces más vas a posponer el hogar que te mereces?',
      q9: 'No trabajamos hasta que terminamos. Trabajamos hasta que tú sonríes.',
      q10: 'JOM Elite — Donde cada proyecto es un testimonio de excelencia.',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      desc: 'Respuestas claras a tus dudas más comunes.',
      q1: 'Es muy caro',
      a1: 'La remodelación barata sale cara dos veces. Con JOM Elite lo haces bien una sola vez con materiales probados y garantía de satisfacción.',
      q2: 'Ya me fallaron antes',
      a2: 'Por eso existimos. Somos una empresa legalmente registrada con un historial de 100+ proyectos anuales. No somos un contratista improvisado.',
      q3: 'No sé si mi espacio se puede remodelar',
      a3: 'Esa es exactamente la conversación que tenemos gratis en la consulta inicial. Llámanos y te decimos qué es posible.',
      q4: '¿Cuánto tiempo toma?',
      a4: 'Depende del proyecto. Lo que garantizamos es comunicación constante para que nunca estés adivinando qué está pasando.',
      q5: '¿Cómo sé que usan materiales de calidad?',
      a5: 'Nuestros materiales son rigurosamente probados bajo nuestros estándares internos. Puedes ver y aprobar los materiales antes de que empecemos.',
    },
    cta: {
      title: 'Tu Próximo Paso Es Simple',
      desc: 'No te pedimos nada complicado. Solo una conversación.',
      t1: 'Urgencia',
      t2: 'Confianza',
      t3: 'Directo',
      c1: 'Tu hogar lleva suficiente tiempo esperando. Hoy es el día que cambia. Llámanos ahora y cuéntanos tu visión.',
      c2: 'Más de 100 familias ya transformaron su hogar con nosotros este año. La próxima eres tú. Contáctanos hoy para tu cotización gratuita.',
      c3: 'Deja de posponer el hogar que mereces. Escríbenos hoy — en 24 horas tienes tu plan de transformación.',
      btn1: 'Enviar Correo',
    },
    footer: {
      tagline: '"Transformamos espacios con calidad y pasión."',
      reg: 'Empresa Registrada LLC',
      file: 'Archivo: L24000141264',
      nav: 'Navegación',
      contact: 'Contacto',
      call: 'Llámanos',
      write: 'Escríbenos',
      location: 'Ubicación',
      locDesc: 'Tampa, Florida',
      rights: 'Todos los derechos reservados.',
      design: 'Diseñado para la excelencia.',
    },
  },
  en: {
    nav: {
      inicio: 'Home',
      problema: 'Problem',
      sistema: 'System',
      trabajos: 'Portfolio',
      nosotros: 'About Us',
      garantia: 'Guarantee',
      faq: 'FAQ',
      tienda: 'Store',
      tiendaOnline: 'Online Store',
      cotizacion: 'Free Quote',
      llamar: 'Call Now',
    },
    hero: {
      badge: 'Remodeling Specialists in Florida',
      title: "Your Outdated Bathroom is Stealing Your Home's Pride Every Day",
      subtitle:
        'The Solution Florida Families Have Been Waiting For — Elite Remodels with a Total Satisfaction Guarantee.',
      trust1: '100+ Bathrooms Transformed / Year',
      trust2: 'Registered LLC Company',
      trust3: 'Satisfaction Guaranteed',
      cta1: 'Call Us: 813-753-4656',
      cta2: 'Free Quote',
      overlayTitle: 'Elite Quality',
      overlaySub: 'Results that last',
    },
    lead: {
      quote: 'Your home speaks for you before you even open your mouth.',
      p1: "Every time someone enters your house, the first thing they see isn't you. They see the walls. They see the floors. They see that bathroom you've been wanting to change for years.",
      p2: 'And you know it.',
      p3: "You know that old bathroom, those cracks, those mismatched fixtures — they don't reflect who you are or how hard you've worked to get what you have.",
      p4: "You've dreamed of that transformation. You've seen it on Pinterest, in YouTube videos, in the home of that relative who finally did it.",
      p5: 'But something has stopped you.',
      p6: "Maybe it was that contractor who took the deposit and disappeared. Maybe it was the poorly done job you had to pay for twice. Or maybe you simply don't know who you can truly trust with your home.",
      p7: 'That is about to change.',
    },
    problem: {
      title: 'The Real Problem Nobody Tells You',
      desc: "Let me be direct with you. It's not that you don't have the money. It's not that you don't have the desire. It's that the construction market is full of people making promises they never keep. You've seen it:",
      p1: 'The contractor who arrived enthusiastic, collected the deposit... and then, nothing.',
      p2: 'The job that looked "almost right" but was already failing 6 months later.',
      p3: 'The cheap materials they used while charging you premium prices.',
      p4: 'The calls they stopped answering when you asked about the details.',
      result:
        'And the result? You lost money. You lost time. And worst of all — you lost the confidence that someone can actually transform your home the way you imagine it.',
      conclusion: 'That is not your problem. It is a market problem.',
    },
    cost: {
      title: 'What Those Outdated Spaces Are Actually Costing You',
      p1: 'Look at your bathroom right now. Do you know how much it costs you emotionally every day that passes without making that change?',
      p2: 'Every morning you wash your face in that old sink. Every time your kids see that damaged floor. Every time you have visitors and secretly hope they don\'t use that bathroom. Every time you see photos of other renovated houses and think: "I could have that too."',
      p3: 'That pride you feel when you look at a well-finished house — you deserve it too.',
      p4: 'Your family works hard. They deserve to live in a home that reflects it.',
    },
    mechanism: {
      badge: 'The JOM Elite Difference',
      title: 'Introducing: The Elite Transformation System™',
      desc: 'After successfully completing more than 100 bathroom remodels each year, we have perfected a system that eliminates exactly the points where others fail. It has 3 layers:',
      c1Title: 'ELITE MATERIALS',
      c1Desc:
        "We don't use what's on sale. We don't use what's convenient for us. We use high-quality, rigorously tested products that meet our internal standards — which are, frankly, higher than what the market demands. Why? Because when we finish a project, our name stays on those walls. And that matters more to us than the cost of the material.",
      c2Title: 'EXECUTION WITH REAL EXPERIENCE',
      c2Desc:
        "There is a huge difference between someone who has done 5 bathrooms and someone who has done more than 100 in a single year. Our team doesn't learn in your house. They are already experts when they arrive at your door. We have seen every type of space, every type of complication, every type of challenge — and we know exactly how to handle it without costing you extra time or money.",
      c3Title: 'TOTAL SATISFACTION COMMITMENT',
      c3Desc:
        "This is what sets us apart the most. For us, the project isn't finished when we say it's finished. It's finished when YOU are completely happy. Period. No excuses. No disappearing. No half-done work. We transform your vision into reality — or we keep working until we achieve it.",
    },
    portfolio: {
      badge: 'Our Portfolio',
      title: 'Real Work. Real Results.',
      desc: "Every bathroom you see here was a family's vision — and we turned it into reality. These are some of the projects we recently delivered.",
      p1Title: 'Premium Marble Shower',
      p1Tag: 'Gold Finishes',
      p2Title: 'Master Suite with Freestanding Tub',
      p2Tag: 'Total Remodel',
      p3Title: 'Modern Black Glass Shower',
      p3Tag: 'Contemporary Style',
      p4Title: 'Boutique Bathroom with Natural Stone',
      p4Tag: 'Exclusive Design',
      p5Title: 'Elegant Family Bathroom',
      p5Tag: 'Luxury Finishes',
      completed: 'Completed Project',
      s1Num: '100+',
      s1Label: 'Bathrooms / Year',
      s2Num: '0',
      s2Label: 'Abandoned Clients',
      s3Num: '100%',
      s3Label: 'Satisfaction',
      s4Num: 'LLC',
      s4Label: 'Registered Company',
    },
    about: {
      title: 'Who We Are — And Why You Should Trust Us',
      p1: 'JOM Elite Construction LLC is not an improvised company.',
      p2: 'We are an officially registered Limited Liability Company (File Number: L24000141264) — which means we have the legal structure, responsibility, and commitment that comes with a serious business.',
      p3: "We specialize in modern home remodeling and premium fixtures with a specific focus on bathroom transformations and spaces that elevate families' quality of life.",
      p4: "We don't do the work and disappear. We are the kind of company you build a relationship with — because we know that when your house needs something in the future, you want to call someone you trust.",
      vTitle: 'Our team is built on three values:',
      v1: 'Quality without compromise',
      v2: 'Professionalism in every step',
      v3: 'Customer satisfaction, always',
    },
    vision: {
      title: 'What Your Life Looks Like After The Transformation',
      p1: 'Imagine this:',
      p2: 'You wake up tomorrow morning. You walk into your bathroom and what you see is clean, modern, elegant. The fixtures shine. The floor is perfect. Everything fits exactly as you imagined it.',
      p3: 'Your kids notice. Your partner notices. When visitors arrive, you no longer hide the bathroom — you show it off with pride.',
      p4: 'And every time you enter that space, you feel something you might not have felt in a long time in your own home:',
      word: 'Pride.',
      desc: 'That is the true result we deliver. Not just a new bathroom. A home that finally reflects who you are.',
    },
    included: {
      title: "What's Included When Working With JOM Elite",
      desc: "When you hire us, you don't just hire labor. You hire the complete system:",
      i1Title: 'Personalized consultation',
      i1Desc: 'We understand your vision before making any proposal',
      i2Title: 'High-quality materials',
      i2Desc: 'Rigorously selected and tested under our standards',
      i3Title: 'Certified expert team',
      i3Desc: 'Professionals with experience in 100+ projects per year',
      i4Title: 'Complete project management',
      i4Desc: 'No stress for you. We coordinate everything',
      i5Title: 'Constant communication',
      i5Desc: 'You know exactly what is happening at every stage',
      i6Title: 'Satisfaction guarantee',
      i6Desc: "The work isn't finished until you are happy",
      i7Title: 'Legally registered company',
      i7Desc: 'Protection, transparency, and institutional seriousness',
    },
    supply: {
      badge: 'Online Store · JOM Elite Supply',
      title1: 'Looking for the Same Materials We Use in ',
      title2: 'Our Remodels',
      desc: 'Now you can buy them directly. Visit our online store and access the same premium fixtures and materials we install in every JOM Elite project.',
      f1: 'Premium Materials',
      f2: 'Direct Prices',
      f3: 'Shipping Available',
      cta: 'Visit Store',
    },
    guarantee: {
      title: 'Our Guarantee — No Fine Print',
      p1: 'We are so confident in our work that we say it directly:',
      quote:
        '"If you are not satisfied with the result, we keep working until you are."',
      p2: 'No excuses. No "we already checked it and it\'s fine." No disappearing.',
      p3: 'Your satisfaction is not a marketing promise. It is how we measure if we did our job.',
    },
    urgency: {
      badge: 'Limited Availability',
      title: 'Why Act Now',
      desc: 'Every day that passes without doing that remodel is another day that:',
      r1: "Your home doesn't reflect what you deserve",
      r2: 'That space continues to deteriorate and cost more later',
      r3: "Your family continues living in something that doesn't represent them",
      r4: 'You lose time you could have spent enjoying your transformed home',
      limitTitle: 'Our Capacity Is Limited',
      limitDesc:
        'Quality projects have a limited schedule. Our team works with a specific number of clients to ensure each project receives the attention it deserves.',
      limitQuote:
        'When the schedule fills up — there is no more room until the next cycle.',
    },
    oneliners: {
      title: 'Why Families Choose JOM Elite',
      q1: 'Your house speaks for you. Make sure it says something good.',
      q2: '100 bathrooms transformed this year. Yours could be next.',
      q3: "We don't build walls — we build family pride.",
      q4: "The contractor who doesn't disappear. We are JOM Elite.",
      q5: 'Your vision. Our obsession with quality. Result: Your ideal home.',
      q6: 'Every crack you ignore is money you are losing.',
      q7: 'Elite materials. Expert team. Satisfaction guaranteed.',
      q8: 'How many more times will you postpone the home you deserve?',
      q9: "We don't work until we're done. We work until you smile.",
      q10: 'JOM Elite — Where every project is a testament to excellence.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      desc: 'Clear answers to your most common doubts.',
      q1: 'It is too expensive',
      a1: 'Cheap remodeling costs you twice. With JOM Elite you do it right once with proven materials and a satisfaction guarantee.',
      q2: 'I have been let down before',
      a2: 'That is why we exist. We are a legally registered company with a track record of 100+ annual projects. We are not an improvised contractor.',
      q3: "I don't know if my space can be remodeled",
      a3: 'That is exactly the conversation we have for free in the initial consultation. Call us and we will tell you what is possible.',
      q4: 'How long does it take?',
      a4: 'It depends on the project. What we guarantee is constant communication so you are never guessing what is happening.',
      q5: 'How do I know you use quality materials?',
      a5: 'Our materials are rigorously tested under our internal standards. You can see and approve the materials before we start.',
    },
    cta: {
      title: 'Your Next Step Is Simple',
      desc: "We don't ask for anything complicated. Just a conversation.",
      t1: 'Urgency',
      t2: 'Trust',
      t3: 'Direct',
      c1: 'Your home has waited long enough. Today is the day it changes. Call us now and tell us your vision.',
      c2: 'More than 100 families have already transformed their home with us this year. You are next. Contact us today for your free quote.',
      c3: 'Stop postponing the home you deserve. Write to us today — in 24 hours you have your transformation plan.',
      btn1: 'Send Email',
    },
    footer: {
      tagline: '"We transform spaces with quality and passion."',
      reg: 'Registered LLC Company',
      file: 'File: L24000141264',
      nav: 'Navigation',
      contact: 'Contact',
      call: 'Call Us',
      write: 'Write Us',
      location: 'Location',
      locDesc: 'Tampa, Florida',
      rights: 'All rights reserved.',
      design: 'Designed for excellence.',
    },
  },
}
